import React from 'react';
import { motion } from 'framer-motion';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <motion.div 
        className="max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-serif font-bold text-blue-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using bigDEAL Capital's website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">2. Use of Services</h2>
            <p className="text-gray-700 mb-4">You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Use our services in any way that violates any applicable laws</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper working of our services</li>
              <li>Use our services to distribute spam or malicious content</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">3. Intellectual Property</h2>
            <p className="text-gray-700 mb-4">
              All content on our website, including articles, images, and logos, is the property of bigDEAL Capital and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our permission.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">4. User Content</h2>
            <p className="text-gray-700 mb-4">
              By submitting content to our website, you grant us a non-exclusive, royalty-free license to use, modify, and display your content. You are responsible for ensuring you have the rights to share any content you submit.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">5. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              bigDEAL Capital is not liable for any damages arising from your use of our services. We provide our services "as is" without any warranties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">6. Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
              We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new terms on our website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">7. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:mitalibharalibusiness@gmail.com" className="text-blue-600 hover:text-blue-800">
                mitalibharalibusiness@gmail.com
              </a>
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
} 